import React, { useEffect, useState } from 'react';
import { DEFAULT_IMAGES, getMenuItemImageUrl } from '../../constants/images';
import { useMediaBaseUrl } from '../MediaConfigProvider/MediaConfigProvider';
import './MenuItemThumbnail.css';

export function resolveMenuItemImageSrc(
  restroId: number | undefined,
  menuId: number | undefined,
  filename: string | undefined
): string {
  if (!restroId || !menuId || !filename || filename === 'default') {
    return DEFAULT_IMAGES.MENU_ITEM;
  }
  return getMenuItemImageUrl(restroId, menuId, filename);
}

type MenuItemThumbnailProps = {
  restroId: number;
  menuId: number;
  filename?: string;
  className?: string;
  imgClassName?: string;
};

const MenuItemThumbnail: React.FC<MenuItemThumbnailProps> = ({
  restroId,
  menuId,
  filename,
  className = 'menu-item-thumb',
  imgClassName,
}) => {
  const mediaBaseUrl = useMediaBaseUrl();
  const [src, setSrc] = useState(() => resolveMenuItemImageSrc(restroId, menuId, filename));

  useEffect(() => {
    setSrc(resolveMenuItemImageSrc(restroId, menuId, filename));
  }, [restroId, menuId, filename, mediaBaseUrl]);

  return (
    <span className={className} aria-hidden>
      <img
        src={src}
        alt=""
        className={imgClassName}
        loading="lazy"
        decoding="async"
        onError={() => {
          setSrc((current) =>
            current !== DEFAULT_IMAGES.MENU_ITEM ? DEFAULT_IMAGES.MENU_ITEM : current
          );
        }}
      />
    </span>
  );
};

export default MenuItemThumbnail;
